import db from "@/db";
import { readStored, writeStored } from "@/utils/safeStorage";

export const PRELOAD_GROUPS = ["mission", "referential"];

const PRELOADS_KEY = "atmo-offline-preloads";
const PRELOAD_FRESH_MS = 24 * 60 * 60 * 1000;

const preloadKey = (group, projectUuid) =>
  group === "mission" ? `mission:${projectUuid}` : group;

const readPreloads = () => {
  try {
    return JSON.parse(readStored(PRELOADS_KEY)) ?? {};
  } catch {
    return {};
  }
};

const isFresh = (at) => !!at && Date.now() - at < PRELOAD_FRESH_MS;

const STILL_STORED = {
  mission: async (projectUuid) => !!(await db.projects.get(projectUuid)),
  referential: async () => (await db.parameters.count()) > 0,
};

export const markPreloaded = (group, projectUuid) => {
  const preloads = Object.fromEntries(
    Object.entries(readPreloads()).filter(([, at]) => isFresh(at))
  );
  preloads[preloadKey(group, projectUuid)] = Date.now();
  writeStored(PRELOADS_KEY, JSON.stringify(preloads));
};

export const preloadedAt = async (group, projectUuid) => {
  const at = readPreloads()[preloadKey(group, projectUuid)];
  if (!isFresh(at)) return null;
  return (await STILL_STORED[group](projectUuid)) ? at : null;
};
